import { format_ShortDOW_Date, getFormattedTimeStamp, getShiftTime } from "./dateTimeFormatter";

var FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(trades, isAdminPage) {
  if (isAdminPage) {
    index = new FlexSearch({
      doc: {
        id: "tradeFormId",
        profile: "speed",
        field: {
          createdAt: {},
          tradeFormType: {},
          visibleTradeStatusAdmin: {},
          workgroup: {},
          offeredEmployeeFirstName: {},
          offeredEmployeeLastName: {},
          offeredEmployeeId: {},
          offeredEmployeeWorkgroup: {},
          offeredShiftStart: {},
          offeredShiftEnd: {},
          requestedEmployeeFirstName: {},
          requestedEmployeeLastName: {},
          requestedEmployeeId: {},
          requestedEmployeeWorkgroup: {},
          requestedShiftStart: {},
          requestedShiftEnd: {},
        },
      },
    });
  } else {
    index = new FlexSearch({
      doc: {
        id: "tradeFormId",
        profile: "speed",
        field: {
          createdAt: {},
          tradeFormType: {},
          visibleTradeStatus: {},
          workgroup: {},
          offeredEmployeeFirstName: {},
          offeredEmployeeLastName: {},
          offeredEmployeeId: {},
          offeredEmployeeWorkgroup: {},
          offeredShiftStart: {},
          offeredShiftEnd: {},
          requestedEmployeeFirstName: {},
          requestedEmployeeLastName: {},
          requestedEmployeeId: {},
          requestedEmployeeWorkgroup: {},
          requestedShiftStart: {},
          requestedShiftEnd: {},
        },
      },
    });
  }

  index.add(trades);
}

export function searchTrades(searchString, applySearchCallback, isAdminPage) {
  if (index) {
    let result = index.where(
      function (item) {
        if (getFormattedTimeStamp(item.createdAt).includes(searchString)) {
          return true;
        }

        if (item.tradeFormType.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (isAdminPage) {
          if (item.visibleTradeStatusAdmin.toLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        } else {
          if (item.visibleTradeStatus.toLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        }

        if (item.workgroup.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const empOne =
          item.offeredEmployeeLastName +
          ", " +
          item.offeredEmployeeFirstName +
          " (" +
          item.offeredEmployeeId +
          ") - " +
          item.offeredEmployeeWorkgroup;
        if (empOne.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const empTwo =
          item.requestedEmployeeLastName +
          ", " +
          item.requestedEmployeeFirstName +
          " (" +
          item.requestedEmployeeId +
          ") - " +
          item.requestedEmployeeWorkgroup;
        if (empTwo.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        const empOneShift =
          format_ShortDOW_Date(item.offeredShiftStart) +
          " " +
          getShiftTime(item.offeredShiftStart) +
          "-" +
          getShiftTime(item.offeredShiftEnd);
        if (empOneShift.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.requestedShiftStart) {
          const empTwoShift =
            format_ShortDOW_Date(item.requestedShiftStart) +
            " " +
            getShiftTime(item.requestedShiftStart) +
            "-" +
            getShiftTime(item.requestedShiftEnd);
          if (empTwoShift.toLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}
